import React, { useEffect, useState } from 'react';
import { TennisLiveApi } from '../../services/TennisLiveApi';
import { ShimmerLoading } from '../LiveScore/ShimmerLoading';
import './RankingsView.css';
import { ChevronUp, ChevronDown, Minus } from 'lucide-react';

interface RankingsViewProps {
  activeFilter: 'ATP' | 'WTA';
  searchQuery?: string;
}

export const RankingsView: React.FC<RankingsViewProps> = ({ activeFilter, searchQuery = '' }) => {
  const [loading, setLoading] = useState(true);
  const [rankings, setRankings] = useState<any[]>([]);

  useEffect(() => {
    const fetchRankings = async () => {
      try {
        setLoading(true);
        const data = await TennisLiveApi.getStandings(activeFilter);
        setRankings(data);
      } catch (error) {
        console.error('Error fetching rankings:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchRankings();
  }, [activeFilter]);

  const filteredRankings = rankings.filter(item => 
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
    (item.country && item.country.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <div className="rankings-container">
      <div className="rankings-list">
        {loading && <ShimmerLoading />}
        
        {!loading && (!filteredRankings || filteredRankings.length === 0) && (
          <div className="rankings-empty">
            Não foi possível carregar os rankings no momento ou nenhum jogador encontrado.
          </div>
        )}

        {!loading && filteredRankings && filteredRankings.length > 0 && (
          <div className="rankings-table">
            <div className="rankings-header-row">
              <span className="col-pos">Pos</span>
              <span className="col-mov">Mov</span>
              <span className="col-player">Jogador</span>
              <span className="col-points">Pontos</span>
            </div>
            
            {filteredRankings.map((item) => {
              const movement = parseInt(item.movement) || 0; 

              return (
                <div key={item.id} className="rankings-row">
                  <span className="col-pos">{item.rank}</span>
                  <span className="col-mov">
                    {movement > 0 && <span className="mov-up"><ChevronUp size={14} /> {movement}</span>}
                    {movement < 0 && <span className="mov-down"><ChevronDown size={14} /> {Math.abs(movement)}</span>}
                    {movement === 0 && <span className="mov-neutral"><Minus size={14} /></span>}
                  </span>
                  <span className="col-player">
                    {item.flagUrl ? (
                      <img src={item.flagUrl} alt={item.country} title={item.country} className="player-country-flag" />
                    ) : item.country ? (
                      <span className="player-country-text">{item.country}</span>
                    ) : null}
                    <span className="player-name">{item.name}</span>
                  </span>
                  <span className="col-points">{item.points}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
